import { render } from "./ads-list.vue?vue&type=template&id=ddb5c84e"
import script from "./ads-list.vue?vue&type=script&lang=js"
export * from "./ads-list.vue?vue&type=script&lang=js"

import "./ads-list.vue?vue&type=style&index=0&id=ddb5c84e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__